import type { AccountType, CoreUser, Profile } from '../types';

function trimmed(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function combinedName(...parts: unknown[]): string {
  return parts.map(trimmed).filter(Boolean).join(' ');
}

export function displayUserName(profile?: Profile | null, user?: CoreUser | null): string {
  const fromPassport = combinedName(profile?.first_name, profile?.last_name);
  if (fromPassport) return fromPassport;

  const fromCoreFull =
    trimmed(user?.fullName) ||
    trimmed(user?.full_name) ||
    trimmed(user?.name);
  if (fromCoreFull) return fromCoreFull;

  const fromCoreParts = combinedName(
    user?.firstName ?? user?.first_name,
    user?.lastName ?? user?.last_name,
  );
  if (fromCoreParts) return fromCoreParts;

  return user?.email || profile?.contact_email || 'User';
}

export function avatarInitial(label: string): string {
  const ch = (label || '?').trim().charAt(0);
  return ch ? ch.toUpperCase() : '?';
}

export function rolesFromClaims(claims: Record<string, unknown>): string[] {
  return Array.isArray(claims.roles)
    ? claims.roles.filter((role): role is string => typeof role === 'string')
    : [];
}

export function accountTypeFromRoles(roles: string[]): AccountType | null {
  const lower = roles.map(role => role.toLowerCase());
  if (lower.includes('verifier')) return 'verifier';
  if (lower.includes('manager')) return 'manager';
  if (lower.includes('employee')) return 'employee';
  return null;
}

export function roleLabel(accountType: AccountType): string {
  if (accountType === 'verifier') return 'Verifier';
  if (accountType === 'manager') return 'Manager';
  return 'Employee';
}

export function userEmail(profile?: Profile | null, user?: CoreUser | null): string | null {
  return user?.email || profile?.contact_email || null;
}
